export default function Notfound(){
    return(
    
        <h1 style={{height:'90vh' ,display: 'flex', justifyContent:'center', alignItems:'center', fontSize:'3rem'}}>404</h1>
    )
}